import React from 'react';
import styles from './ReleaseNotes.module.css';
import '../styles/mpd.css';

export default function ReleaseNotes() {
  const releases = [
    /*{
      version: '1.0.4',
      date: 'December 2024',
      features: [
        'Enhanced Google Analytics 4 tracking with comprehensive e-commerce events',
        'Improved PayPal subscription system with annual $20/year option',
        'Added password reset functionality with secure email tokens',
        'Enhanced affiliate tracking for recurring subscription commissions',
        'Updated UI with "Most Popular" badges for subscription plans',
        'Improved email notifications for different purchase types'
      ]
    },
    {
      version: '1.0.3',
      date: 'November 2024',
      features: [
        'Added comprehensive groups functionality with nested hierarchies',
        'Implemented smart group creation and multi-group membership',
        'Enhanced visual group management with dynamic filtering',
        'Added group-based actions and bulk operations',
        'Created dedicated Features Groups page with detailed use cases',
        'Improved contact organization with professional and personal groupings'
      ]
    },
    {
      version: '1.0.2',
      date: 'October 2024',
      features: [
        'Added ability to manage contacts of deceased individuals',
        'Enhanced contact status management for life events',
        'Improved data retention while maintaining active contact lists',
        'Added memorial and legacy contact features',
        'Enhanced privacy controls for sensitive contact information',
        'Improved backup and restore functionality'
      ]
    },
    {
      version: '1.0.1',
      date: 'September 2024',
      features: [
        'Enhanced search functionality with advanced filters',
        'Improved contact import/export capabilities',
        'Added bulk contact operations',
        'Enhanced data validation and error handling',
        'Improved performance for large contact databases',
        'Fixed various UI/UX issues based on user feedback'
      ]
    },
    */
    {
      version: '1.0.0',
      date: 'August 2025',
      features: [
        'Initial release of MyPeopleDatabase',
        'Core contact management functionality',
        'Group contact organization and categorization',
        //'Advanced search and filtering capabilities',
        'Data import/export functionality',
        'Cross-platform support (Mac and Windows)',
        'Secure local data storage',
        'Intuitive user interface design',
      ],
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>Release Notes</h1>
        <p className={styles.subtitle}>
          Stay up to date with the latest features and improvements in MyPeopleDatabase
        </p>

        <div className={styles.releasesContainer}>
          {releases.map((release, index) => (
            <div key={release.version} className={styles.releaseCard}>
              <div className={styles.releaseHeader}>
                <h2 className={styles.versionTitle}>
                  Version {release.version}
                  {index === 0 && <span className={styles.latestBadge}>Latest</span>}
                </h2>
                <span className={styles.releaseDate}>{release.date}</span>
              </div>

              <div className={styles.featuresSection}>
                <h3>What's New</h3>
                <ul className={styles.featuresList}>
                  {release.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className={styles.featureItem}>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.downloadSection}>
          <h2>Ready to Update?</h2>
          <p>Download the latest version to get all these great features.</p>
          <a href="/download" className={styles.downloadButton}>
            Download Latest Version
          </a>
        </div>

        <div className={styles.supportSection}>
          <h3>Questions or Feedback?</h3>
          <p>
            We'd love to hear from you! Contact us at{' '}
            <a href="mailto:support@mypeopledatabase.com">support@mypeopledatabase.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}
